<template lang="html">
  <div style="width: 100%; display: flex; justify-content: center;">
      <div
        id="g_id_onload"
        data-nonce=""
        data-auto_select="true"
        data-itp_support="true"
        data-context="use"
        data-ux_mode="popup"
        :data-client_id="clientId"
        :data-callback="callbackName"
        style="display: flex; justify-content: center; width: fit-content-box;"
      >
      </div>
      <div class="g_id_signin" data-type="standard"
        data-shape="rectangular"
        data-theme="outline"
        data-text="signin_with"
        data-size="large"
        data-logo_alignment="left"
        data-width="240"
        data-locale="en"
        data-button_type="standard"
      ></div>

      </div>
  </template>

<script>

export default {
  emits: ['loginGoogle'],
  name: 'GoogleSignIn',
  data() {
    return {
      clientId: this.client_id_gsi,
      callbackName: "handleCredentialResponse",
      loading: false,
      snackbar: false,
      errorMsg: null,
    };
  },
  mounted() {
    // Load the Google Sign-In script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Define the callback function
    window.handleCredentialResponse = this.handleCredentialResponse;
  },
  methods: {
    handleCredentialResponse(response) {
      this.$emit('loginGoogle', response)
    },
  }
};
</script>

<style scoped>
</style>
